import type { ValidatedKey } from '@festina-life/core'
import { useField } from 'formik'
import get from 'lodash-es/get'
import { useMemo } from 'react'

import { useFormikContext } from '../../hooks/useFormikContext'
import { useExistingValuesContext } from '../../theme/existingValuesContext'

export const useSimpleValueDifferenceCheck = (name: ValidatedKey) => {
  const [field] = useField(name)
  const {
    initialValues,
    status: { shouldShowChangesInForm },
  } = useFormikContext()

  const existingValue = useExistingValuesContext()?.getExistingValue?.(
    name,
  ) as string

  const initialValue = useMemo(
    () => get(initialValues, name),
    [initialValues, name],
  )

  return useMemo(() => {
    if (!shouldShowChangesInForm) {
      return undefined
    }

    const previous = existingValue ?? initialValue
    return field.value === previous ? 'identical' : 'different'
  }, [existingValue, field.value, initialValue, shouldShowChangesInForm])
}
